export default {
  window: state => state.window.window,
};
